import axios from "./HttpRequestCampaign";

     function getListcampaign(page, size){
         return  axios.get('/PromotionV2/getall_promotion_muahang_tangqua_v2?page_index='+page+'&page_size='+size);
    }

    function getListcampaignV1(page, size){
      return  axios.get('/Promotion_AB_AA/getall_promotion_AB_AA?page_index='+page+'&page_size='+size);
 }

    function getListBanner(location){
        //M004TOP
        return  axios.get('/Banner/get_banner_app?MaViTri='+location);
   }

   function getListGift(sku){
     return  axios.get('/Promotion/getall_promotion_muahang_tangqua_gifts_sku?mahang='+sku);
   }
   function getListGiftDetail(sku, type){
    return  axios.get('/Promotion_AB_AA/detail_muaatanga_gifts_sku?mahang='+sku+'&typectkm='+type);
  }
   function getListGift_v1(sku, type){
    return  axios.get('/Promotion_AB_AA/muaatanga_combo_gifts?mahang='+sku+'&typectkm='+type);
  }

   function getListPromotion(param){
     return  axios.post('/PromotionV2/get_promotion_list_gifts_sku_v3', param);
   }
   function getListComboGiftInGroupSku(param){
      return  axios.post('/PromotionV2/List_combo_gifts_in_group_sku_v2', param);
   }
   function getListPromotion_v1(param, type){
    return  axios.post('/Promotion_AB_AA/muaatanga_list_gifts_sku?typectkm='+type, param);
  }
  function getListPromotion_v2(param, type){
    return  axios.post('/Promotion_AB_AA/muaatanga_list_gifts_sku_v2?typectkm='+type, param);
  }
  //mobile
  function getBannerMobile(MaManHinh){
    return  axios.get('/Banner/get_banner?MaManHinh='+MaManHinh);
  }
  function getListGroup(){
    return  axios.get('/Promotion_AB_AA/get_list_group');
  }
  function getListcampaignByGroup(page, size, group){
    let _param = '';
    if(group !== null){
      _param = '&group='+group;
    }
    return  axios.get('/Promotion_AB_AA/getall_promotion_AB_AA?page_index='+page+'&page_size='+size+_param);
  }

  function getUrlShare(param){
    return axios.post('/Sharelink/get_link', param);
  }
export {getListcampaign,getListBanner,getListGift, getListPromotion, getListcampaignV1,getListGift_v1,
  getListPromotion_v1,getListGiftDetail, getBannerMobile,getListGroup, getListcampaignByGroup, getUrlShare, getListComboGiftInGroupSku,getListPromotion_v2}